import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    constructor(private httpClient: HttpClient, @Inject(Restangular) public Restangular: any) {
    }

    getTypes(options: string) {
        return this.Restangular.one('analysis/type?' + options).customGET('');
    }

    getDashboardStats(options: string) {
        debugger;
        return this.Restangular.one('reports/dashboard' + options).customGET('');
    }

    getUserStats(options: string) {
        debugger;
        return this.Restangular.one('reports/users/stats' + options).customGET('');
    }

}
